"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALENDAR_UPDATE = 'CALENDAR_UPDATE';
exports.CALENDAR_NO_SUBSCRIPTION = 'NO_SUBSCRIPTION';
exports.EVENT_TIME_DEFAULT = 0;
exports.CALENDAR_UPDATE_INTERVAL = 10 * 1000; // Update calendar every 10 seconds



//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/clients.remoting/dist/constants/calendar.js
// module id = 103
// module chunks = 0